export enum eCurativeGrade {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}

export const prettyCurativeGrade: Record<eCurativeGrade, string> = {
  [eCurativeGrade.A]: 'Grade A',
  [eCurativeGrade.B]: 'Grade B',
  [eCurativeGrade.C]: 'Grade C',
  [eCurativeGrade.D]: 'Grade D',
};

export const curativeGradeColors: Record<eCurativeGrade, string> = {
  [eCurativeGrade.A]: '#72c957',
  [eCurativeGrade.B]: '#f4cd52',
  [eCurativeGrade.C]: '#f9a44d',
  [eCurativeGrade.D]: '#ff665c',
};
